export enum GridColumnMode {
  None = 0,
  View = 1,
  Edit = 2,
  ViewAndEdit = View | Edit,
  AddOnly = 4
}
